import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  RatingToolRequest,
  RatingToolResponse,
} from '@app/pages/authenticated/pages/rating-tool/utils/rating-tool.interface';
import { environment } from '../../../environments/environment';
import { catchError, Observable, repeat, takeWhile, throwError } from 'rxjs';
import { ErrorMessages } from '../constants';

export type RatingToolJobResult = {
  downloadLink: string;
  success: number;
  error: number;
  skipped: number;
  // Whether utility-services accepted the Slack post (not whether Slack received it). The export is in
  // the bucket either way, so the download link is the fallback.
  queued: boolean;
};

export type RatingToolJobStatus = {
  state: 'waiting' | 'active' | 'completed' | 'failed' | 'unknown';
  progress: number;
  failedReason?: string;
  // Present once state is 'completed'
  result?: RatingToolJobResult;
};

@Injectable({ providedIn: 'root' })
export class RatingToolService {
  private static readonly POLLING_MS = 2000;
  private static readonly TERMINAL_STATES = new Set(['completed', 'failed', 'unknown']);

  constructor(private http: HttpClient) {}

  public fetchMachoolRates(request: RatingToolRequest): Observable<RatingToolResponse> {
    return this.http
      .post<RatingToolResponse>(`${environment.INTEGRATION_SERVICES_URL}/admin/shipment/rating-tool`, request)
      .pipe(catchError((error) => throwError(() => error || ErrorMessages.UNEXPECTED)));
  }

  public pollJob(jobId: string | undefined): Observable<RatingToolJobStatus> {
    if (!jobId) {
      return throwError(() => new Error('Failed to get job id for rating tool.'));
    }
    return this.http
      .get<RatingToolJobStatus>(`${environment.INTEGRATION_SERVICES_URL}/admin/shipment/rating-tool/${jobId}`)
      .pipe(
        repeat({ delay: RatingToolService.POLLING_MS }),
        takeWhile((job) => !RatingToolService.TERMINAL_STATES.has(job.state), true),
        catchError((error) => throwError(() => error || ErrorMessages.UNEXPECTED)),
      );
  }
}
